import { render, staticRenderFns } from "./sofinishkz.vue?vue&type=template&id=a63fd174&scoped=true&"
import script from "./sofinishkz.vue?vue&type=script&lang=js&"
export * from "./sofinishkz.vue?vue&type=script&lang=js&"
import style0 from "./sofinishkz.vue?vue&type=style&index=0&id=a63fd174&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a63fd174",
  null
  
)

export default component.exports